module.exports = __webpack_public_path__ + "static/media/high-banner.b99ad003.jpg";